import React, { memo, useState, useEffect, useRef } from 'react';
import BaseNode from './BaseNode';
import { Download } from 'lucide-react';

const ImageNode = ({ data, onChange, onSubmit }) => {
  const changeHandler = onChange || data.onChange || (() => {});
  const [imageUrl, setImageUrl] = useState(data.imageUrl || '');
  const fileInputRef = useRef(null);

  useEffect(() => {
    setImageUrl(data.imageUrl || '');
  }, [data.imageUrl]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const url = ev.target.result;
        setImageUrl(url);
        if (typeof changeHandler === 'function') {
          changeHandler({ imageUrl: url });
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClick = (e) => {
    if (!imageUrl && fileInputRef.current) {
      e.stopPropagation();
      fileInputRef.current.click();
    }
  };

  return (
    <BaseNode data={{ ...data, imageUrl }} onChange={changeHandler} onSubmit={onSubmit} nodeType="imageNode">
      <div className="image-node" onClick={handleClick}>
        {imageUrl ? (
          <div className="image-wrapper">
            <img
              src={imageUrl}
              alt={data.title || 'Image Node'}
              className="image-content"
            />
            <a
              href={imageUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="image-download"
              onClick={(e) => e.stopPropagation()}
            >
              <Download size={14} />
            </a>
          </div>
        ) : (
          <div className="image-placeholder">Click to upload image</div>
        )}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </div>
    </BaseNode>
  );
};

export default memo(ImageNode);
